import { render, staticRenderFns } from "./MediaMobile.vue?vue&type=template&id=8552589e&scoped=true&"
import script from "./MediaMobile.vue?vue&type=script&lang=js&"
export * from "./MediaMobile.vue?vue&type=script&lang=js&"
import style0 from "./MediaMobile.vue?vue&type=style&index=0&id=8552589e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552589e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
